import React from 'react';

const AuthContext = React.createContext<{token: string | null, setToken: (token: string | null) => void}>({token: '', setToken: (token: string | null) => {}});

export default AuthContext;